/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Studentform_Phone_HintInputs */

const en_studentform_phone_hint = /** @type {(inputs: Studentform_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(e.g. 972501234567)`)
};

const he_studentform_phone_hint = /** @type {(inputs: Studentform_Phone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(לדוגמה 972501234567)`)
};

/**
* | output |
* | --- |
* | "(e.g. 972501234567)" |
*
* @param {Studentform_Phone_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const studentform_phone_hint = /** @type {((inputs?: Studentform_Phone_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studentform_Phone_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_studentform_phone_hint(inputs)
	return he_studentform_phone_hint(inputs)
});